import { EventEmitter, Injectable } from '@angular/core';
import { MessageSystemDTO, MessageSystemNavigationDTO } from '../../shared/models/models.model';

@Injectable({ providedIn: 'root' })
export class ListenerService {
	private _eventMessageSystem: EventEmitter<MessageSystemDTO> =
		new EventEmitter<MessageSystemDTO>();
	private _eventMessageSystemNavigation: EventEmitter<MessageSystemNavigationDTO> =
		new EventEmitter<MessageSystemNavigationDTO>();

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------
	messageSystemEmit(value: MessageSystemDTO) {
		this._eventMessageSystem.emit(value);
	}

	messageSystem(): EventEmitter<MessageSystemDTO> {
		return this._eventMessageSystem;
	}

	messageSystemNavigationEmit(value: MessageSystemNavigationDTO) {
		this._eventMessageSystemNavigation.emit(value);
	}
	messageSystemNavigation(): EventEmitter<MessageSystemNavigationDTO> {
		return this._eventMessageSystemNavigation;
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
